module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD_20.4b26d9f1.svg";